const formElem = document.querySelector(".js-form-contact");

if (formElem) {
    $(formElem).validate({
        rules: {
            message: {
                minlength: 100,
            },
            phone: {
                phone: true,
            },
        },
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass("is-loading");
            $(".js-contact-error").slideUp(100);

            window.assignRecaptchaResponseToForm(form).then(() => {
                Form.ajaxPost(
                    form,
                    function (data) {
                        if (!data.status) {
                            $(".js-contact-error").text(data.message).slideDown(250);
                        } else {
                            $(".js-contact-success").addClass("is-visible");

                            if (window.location.hash == "#contact-modal") {
                                history.pushState("", document.title, window.location.pathname);
                            }

                            window.location.reload();
                        }

                        $(form).find('button[type="submit"]').removeClass("is-loading");
                    },
                    "json"
                );
            });
        },
    });
}
